"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stickiness = void 0;
const React = __importStar(require("react"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const StickinessPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/StickinessPopover");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const ProjectHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectHighchartsOptionsProvider");
const StickinessApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessApiService");
const lodash_1 = __importDefault(require("lodash"));
const HighchartsComponentWrapper_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsComponentWrapper");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const StickinessChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessChartSettingsJSONModel");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const StickinessJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessJSONModel");
const title = "Stickiness";
const Stickiness = () => {
    var _a, _b, _c, _d, _e, _f;
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const currentProjectDataContext = (0, ProjectDashboardDataProvider_1.useProjectDashboardDataContext)();
    const state = currentProjectDataContext.stateQueryCalls;
    if ((_b = (_a = state.data) === null || _a === void 0 ? void 0 : _a.stickiness) === null || _b === void 0 ? void 0 : _b.isError) {
        return React.createElement(React.Fragment, null,
            React.createElement(PageContent_1.default.CardSection, null, title),
            React.createElement(antd_1.Result, { className: "ug-result-noIcon", status: "error", icon: React.createElement(React.Fragment, null), subTitle: React.createElement(React.Fragment, null,
                    "Oops, something went wrong.",
                    React.createElement("br", null),
                    title,
                    " cannot be loaded. Please try again.") }));
    }
    const inProgress = state.inProgress;
    const classicParameters = {
        ...StickinessChartSettingsJSONModel_1.StickinessChartSettingsJSONModel.getDefaultModel(),
        lineType: LineTypeJSONModel_1.LineType.nonCumulative,
        shouldAddPeriod: true
    };
    const classicCumulativeParameters = {
        ...StickinessChartSettingsJSONModel_1.StickinessChartSettingsJSONModel.getDefaultModel(),
        lineType: LineTypeJSONModel_1.LineType.cumulative,
        shouldAddPeriod: true
    };
    const highchartsOptionsProviderFn = ProjectHighchartsOptionsProvider_1.ProjectHighchartsOptionsProvider.getStickiness;
    const data = {
        request: {
            periodType: ProjectDashboardDataProvider_1.dashboardStickinessChunksParameters.periodType,
            lineType: ProjectDashboardDataProvider_1.dashboardStickinessChunksParameters.lineType,
            cohortQuery: [...ProjectDashboardDataProvider_1.dashboardStickinessChunksParameters.cohortQuery],
            returnQuery: [...ProjectDashboardDataProvider_1.dashboardStickinessChunksParameters.returnQuery]
        },
        response: (_d = (_c = state.data) === null || _c === void 0 ? void 0 : _c.stickiness) === null || _d === void 0 ? void 0 : _d.data
    };
    const dateCumulative = lodash_1.default.cloneDeep(data);
    if ((_e = dateCumulative === null || dateCumulative === void 0 ? void 0 : dateCumulative.response) === null || _e === void 0 ? void 0 : _e.chartData) {
        dateCumulative.response.chartData = (0, StickinessApiService_1.makeChartDataCumulative)(dateCumulative.response.chartData);
    }
    const jsonModelForURL = new StickinessJSONModel_1.StickinessJSONModel();
    jsonModelForURL.getPeriodDaysJSONModel().setLast(data.request.periodType.last);
    jsonModelForURL.getLineTypeJSONModel().setLineType(data.request.periodType.last);
    jsonModelForURL.getTabsJSONModel().addItem({
        cohort: CommonTypesConversions_1.CommonTypesConversions.queryEventVariants.queryEventVariantsJSONModelFromQueryEventVariant(data.request.cohortQuery).serialize(),
        return: CommonTypesConversions_1.CommonTypesConversions.queryEventVariants.queryEventVariantsJSONModelFromQueryEventVariant(data.request.returnQuery).serialize()
    }, false);
    const error = (0, DataProviderCommonTypes_1.getDataProviderStateErrorFromCommonState)((_f = state.data) === null || _f === void 0 ? void 0 : _f.stickiness);
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSection, null,
            React.createElement(antd_1.Space, null,
                React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.stickiness(projectApiKey, jsonModelForURL.serialize()) }, title),
                React.createElement(StickinessPopover_1.StickinessPopover, null))),
        React.createElement(antd_1.Row, { gutter: [32, 16] },
            React.createElement(antd_1.Col, { span: 24, lg: 12 },
                React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: error, data: data, parameters: classicParameters, highchartsOptionsProviderFn: highchartsOptionsProviderFn },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                        return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                    }))),
            React.createElement(antd_1.Col, { span: 24, lg: 12 },
                React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: error, data: dateCumulative, parameters: classicCumulativeParameters, highchartsOptionsProviderFn: highchartsOptionsProviderFn },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                        return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                    })))));
};
exports.Stickiness = Stickiness;
